export function splitText(text: string, lineLength: number): string[] {
  const result: string[] = [];
  let remainingText = text.trim();

  while (remainingText.length > lineLength) {
    const rawPart = remainingText.substring(0, lineLength);
    const lastSpaceIndex = rawPart.lastIndexOf(" ");

    let part: string;

    if (lastSpaceIndex >= 0) {
      part = remainingText.substring(0, lastSpaceIndex);
    } else {
      part = remainingText.substring(0, lineLength);
    }
    result.push(part.trim());
    remainingText = remainingText.slice(part.length).trim();
  }
  result.push(remainingText);

  return result;
}
